import { STATUSPAGE } from '@repo/ui';
import {
  DeleteActivityUseCaseInterface,
  GetActivityByIdUseCaseInterface,
  GetAllPersonActivitiesUseCaseInterface,
} from 'domain/usecases';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';

export const usePersonActivitiesTab = () => {
  //hooks
  const { personService, activityService } = useService();

  // states
  const [loadingActivities, setLoadingActivities] = useState<boolean>(false);
  const [requestStatus, setRequestStatus] = useState<STATUSPAGE>(
    STATUSPAGE.INITIAL,
  );

  const [activities, setActivities] =
    useState<GetAllPersonActivitiesUseCaseInterface.Result>([]);

  const [loadingActivity, setLoadingActivity] = useState<boolean>(false);

  const [activity, setActivity] =
    useState<GetActivityByIdUseCaseInterface.Result>(null);

  const [loadingDeleteActivity, setLoadingDeleteActivity] =
    useState<boolean>(false);

  // functions
  const requestGetAllPersonActivities = useCallback(
    async (params: GetAllPersonActivitiesUseCaseInterface.Params) => {
      setLoadingActivities(true);
      setRequestStatus(STATUSPAGE.LOADING);

      try {
        const res = await personService.getAllPersonActivities(params);
        setActivities(res);
        setRequestStatus(STATUSPAGE.DONE);
      } catch (err) {
        setActivities([]);
        setRequestStatus(STATUSPAGE.ERROR);
        notifyError(
          err instanceof Error ? err.message : 'Erro ao buscar atividades',
        );
      } finally {
        setLoadingActivities(false);
      }
    },
    [personService],
  );

  const requestGetActivityById = useCallback(
    async (params: GetActivityByIdUseCaseInterface.Params) => {
      setLoadingActivity(true);
      setActivity(null);

      try {
        const res = await activityService.getActivityById(params);
        setActivity(res);
      } catch (err: unknown) {
        console.log(err);
      } finally {
        setLoadingActivity(false);
      }
    },
    [activityService],
  );

  const requestDeleteActivity = useCallback(
    async (
      params: DeleteActivityUseCaseInterface.Params,
      onSuccess: () => void,
    ) => {
      setLoadingDeleteActivity(true);

      try {
        const res = await activityService.deleteActivity(params);
        onSuccess();
        notifySuccess(res.message || 'Atividade excluída com sucesso');
      } catch (err) {
        notifyError(
          err instanceof Error ? err.message : 'Erro ao excluir atividade',
        );
      } finally {
        setLoadingDeleteActivity(false);
      }
    },
    [activityService],
  );

  return {
    activities,
    requestStatus,
    activity,
    loadingActivity,
    loadingActivities,
    loadingDeleteActivity,
    requestGetActivityById,
    requestDeleteActivity,
    requestGetAllPersonActivities,
  };
};
